<div class="quill-editor-container" [style.height]="editorHeight">
    <div #editor></div>
</div>
